export default {
  'limits.allowFreeform': 'Allow Freeform',
  'limits.accountType': 'Account Type',
  'limits.ach': 'ACH Transaction Date',
  'limits.achLimits': 'ACH Transaction Date Limits',
  'limits.achOverallActivation': 'ACH Overall Activation',
  'limits.achOverallApproval': 'ACH Overall Approval',
  'limits.amountLimit': 'AMOUNT LIMIT (PER BATCH)',
  'limits.approvalDay': 'Approval/Day',
  'limits.approvalTxn': 'Approval/Transaction',
  'limits.approvalDayOverall': 'Overall Approval/Day',
  'limits.approvalTxnOverall': 'Overall Approval/Transaction',
  'limits.approvalType': 'Approval Type',
  'limits.batchActivation': 'Initiation',
  'limits.batchApproval': 'Approval',
  'limits.bookTransferLimits': 'Transfer Limits',
  'limits.cannotExceed': 'The limit cannot exceed <%= name %> Limit.',
  'limits.cannotExceedAmount': 'The limit cannot exceed <%= amount %>.',
  'limits.company': 'Company',
  'limits.default': 'Amount cannot exceed $99,999,999.99',
  'limits.entryDay': 'Entry/Day',
  'limits.entryTxn': 'Entry/Transaction',
  'limits.entryDayOverall': 'Overall Entry/Day',
  'limits.entryTxnOverall': 'Overall Entry/Transaction',
  'limits.expeditedErrorSign': 'Expedited payments limits cannot exceed Customer level limits',
  'limits.expeditedLimits': 'Expedited Payments Limits',
  'limits.expeditedPayments': 'Expedited Payments',
  'limits.failedAddingLimits': 'User limits are not saved. Default limits are applied.',
  'limits.failModifyingLimits': 'User limits are not saved.',
  'limits.loanLimit': 'Loan',
  'limits.loanLimits': 'Loan Limits',
  'limits.mainHeader': 'Assign Limits',
  'limits.maxPerDay': 'Max # Per Day',
  'limits.mustExceed': 'The limit must exceed <%= name %> Limit.',
  'limits.noAssignedLimitsError':
    'No Limits assigned for this user and are required to permit transactions.',
  'limits.rck': 'Amount must be less than $2500.00',
  'limits.transfer': 'Transfer',
  'limits.validationErrorWarning': 'Please correct <%= limitsGroups %> Limits.',
  'limits.wire': 'Wire Transfer',
  'limits.wireErrorSign': 'Wire Transfer Limits cannot exceed Customer Level Limits',
  'limits.wireLimits': 'Wire Transfer Limits',
  'limits.bookTransferLimitHeading': ' Transfer Limits cannot exceed Customer Level Limits',
  'limits.txLimitIs': 'Transaction Limit for transfers is <%= amount %>',
  'limits.dailyLimitIs': 'Daily Limit for transfers is <%= amount %>',

  'limits.achError': 'Something went wrong, displaying the ach limits summary.',
  'limits.wireError': 'Something went wrong, displaying the wire limits summary.',

  'limits.setUserLimitsByCompany': 'Set user limits by company',
  'limits.deferToCompanyLimits': 'Defer to company limits',
  'limits.deferToCustomerLimits': 'Defer to customer limits',
  'limits.setUserLimitsByAccount': 'Set user limits by account',

  'limits.overallCombinedLimits': 'Overall Combined Limits',

  'limits.defaultOverallNumberPerDay': 'Account overall Number Per Day',
  'limits.defaultMaximumNumberPerDay': 'Account max Number Per Day',
  'limits.defaultMaximumApprovalPerDay': 'Account max Approval Per Day',
  'limits.defaultMaximumApprovalPerTxn': 'Account max Approval Per Txn',
  'limits.defaultMaximumEntryPerDay': 'Account max Entry Per Day',
  'limits.defaultMaximumEntryPerTxn': 'Account max Entry Per Txn',

  'limits.defaultWire': 'Amount cannot exceed $9,999,999,999.99',
  'limits.showWireTransferLimitsTable': 'Show Wire Transfer Limits Table'
};
